// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gf-diff-statistics{display:flex;gap:12px;align-items:center;flex-wrap:wrap;text-wrap:nowrap}.gf-diff-statistics .gf-diff-statistics__lines{display:flex;align-items:center;gap:8px}.gf-diff-statistics .gf-diff-statistics__lines-squares{display:flex;gap:1px}.gf-diff-statistics .gf-diff-statistics__lines-squares-item{width:8px;height:8px;border-radius:2px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
